module.exports = "2b590a303aba317ae166505325b98a28.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/goal.png
// module id = 73
// module chunks = 0